import { Credentials } from "auth";
import { Organization } from "generated/graphql";
import { ClientApp } from "models";
import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { State } from "redux/state";

export type CreateApp = "CREATE_APP";
export const CREATE_APP: CreateApp = "CREATE_APP";
export type CreateAppEnd = "CREATE_APP_END";
export const CREATE_APP_END: CreateAppEnd = "CREATE_APP_END";

export interface CreateAppAction extends Action {
    type: CreateApp;
    payload: {
        app: ClientApp;
        credentials: Credentials;
        organization: Organization;
    };
}

export function createApp(app: ClientApp): ThunkAction<void, State, undefined, CreateAppAction> {
    return (dispatch: Dispatch<CreateAppAction>, getState) => {
        const credentials = getState().auth.credentials;
        const organization = getState().org.currentOrg;
        dispatch(createAppWithCredentials(app, organization, credentials));
    };
}

function createAppWithCredentials(app: ClientApp, organization: Organization, credentials: Credentials): CreateAppAction {
    return {
        payload: {
            app: app as ClientApp,
            credentials,
            organization
        },
        type: CREATE_APP
    };
}

export interface CreateAppEndAction extends Action {
    type: CreateAppEnd;
    payload: {
        app?: ClientApp;
        error?: Error;
    };
}

export function createAppEnd(error: Error, app?: ClientApp): CreateAppEndAction {
    return {
        payload: {
            app,
            error
        },
        type: CREATE_APP_END
    };
}
